import headerMenu from './header-menu.vue'
export default headerMenu
